export const iconFontAwesomeDisasterCrisisHillAvalanche = (
	<i className="fa-solid fa-hill-avalanche"></i>
);
